document.addEventListener("DOMContentLoaded", () => {
    const params = new URLSearchParams(location?.search || "");
    const customerNew = params.get("new");
    // let customerType = params.get("perfil");
    let customerType = decodeURIComponent(location.pathname?.split('/')?.reverse()[0] || "");
    const welcomeHeading = document.querySelector(".contaWelcomeHeading h3");
    const advantagesHeading = document.querySelector(".advantagesHeading span");

    switch (customerType) {
        case "aluno":
        case "encarregado-de-educação":
        case "encarregado-de-educa%C3%A7%C3%A3o":
            document.querySelector(".obrigado-container")?.classList.remove("professor-bg");
            document.querySelector(".obrigado-container")?.classList.add("aluno-bg");
            break;
        case "professor":
        case "professor-educador":
            document.querySelector(".grid").style.display = "flex";
            document.querySelector(".obrigado-container")?.classList.remove("aluno-bg");
            document.querySelector(".obrigado-container")?.classList.add("professor-bg");
            showAdvantagesCards("all");
            break;
    
        default:
            break;
    }


    function showAdvantagesCards(cardText) {
        document.querySelectorAll(".customerWelcomePage .card").forEach((card) => {
            if (cardText == "all") {
                card.style.display = "block";
            } 
            else if (card.id.includes(cardText))
            {
                card.style.display = "block";
            }
            else
            {
                card.style.display = "none";
            }
        });
    }
})